import { render, staticRenderFns } from "./HealthCare.vue?vue&type=template&id=4a6f27e1&scoped=true&"
import script from "./HealthCare.vue?vue&type=script&lang=js&"
export * from "./HealthCare.vue?vue&type=script&lang=js&"
import style0 from "./HealthCare.vue?vue&type=style&index=0&id=4a6f27e1&lang=scss&scoped=true&"
import style1 from "./HealthCare.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f27e1",
  null
  
)

export default component.exports